import { render } from "./WCNestedSidebarPanel.vue?vue&type=template&id=a382e1a4&scoped=true"
import script from "./WCNestedSidebarPanel.vue?vue&type=script&lang=js"
export * from "./WCNestedSidebarPanel.vue?vue&type=script&lang=js"

import "./WCNestedSidebarPanel.vue?vue&type=style&index=0&id=a382e1a4&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a382e1a4"]])

export default __exports__